<template>
  <div class="notes">
    <va-card :title="$t('order.notes.notes')">
      <chat v-model="notes" @insertNote="insertNote"/>
    </va-card>
  </div>
</template>

<script>
import Chat from './Chat'
export default {
  name: 'notes',
  components: { Chat },
  data () {
    return {
      notes : null
    }
  },
  created(){
    this.getNotes();
  },
  
  methods: {
    getNotes(){
      this.$axios.get('api/orders/getNotes',{params: {orderUuid: this.$route.params.uuid}})
      .then(axRes => {
        var arr = []
        for(var i in axRes.data){
          var obj = {};
          obj.text = axRes.data[i].text;
          obj.yours = true;
          arr.push(obj);
        }
        this.notes = arr;

      }).catch(axErr => {
        this.showToast(
          this.$t('system.genericError'),
            {
              icon:'fa-warning',
              position: 'bottom-right',
              duration: 10000,
              fullWidth: false,
              className: 'vuestic-toast error'
            },
          )
        })
    },
    insertNote(note){

      this.$axios.post('api/orders/createNote',{orderUuid: this.$route.params.uuid,nota:note})
      .then(axRes => {
        this.getNotes();
      }).catch(axErr => {
        this.showToast(
          this.$t('system.genericError'),
            {
              icon:'fa-warning',
              position: 'bottom-right',
              duration: 10000,
              fullWidth: false,
              className: 'vuestic-toast error'
            },
          )
        })


    }
  },
}
</script>